module.exports = __webpack_public_path__ + "img/manage-acc.09044fc.svg";